module.exports = __webpack_public_path__ + "img/astral_11.979d9dd8.svg";